var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import axios from "axios";
import { useNavigate, useSearchParams, } from "react-router-dom";
import { clearOauthAttemptFlag, clearWecomOAuthFail, clearWecomOauthReturnPath, setWecomOAuthFail, takeWecomOauthReturnPathOrFallback, } from "./wecomOAuth";
import { resolveApplicationId, wecomLogin } from "./wecomMsOrgApi";
import { getWecomMsOrgToken, setWecomMsOrgToken, } from "./tokenStorage";
/** 换票页提示：避免静态 message 在 Vite+antd-mobile 等组合下抛错顶飞 ErrorBoundary */
function toastError(text) {
    try {
        void import("antd")
            .then(function (m) {
            try {
                m.message.error(text);
            }
            catch (e) {
                console.error("[WecomMsOrgCallbackPage]", text, e);
            }
        })
            .catch(function () {
            console.error("[WecomMsOrgCallbackPage]", text);
        });
    }
    catch (e) {
        console.error("[WecomMsOrgCallbackPage]", text, e);
    }
}
function wecomLoginErrorMessage(e) {
    var _a, _b;
    if (axios.isAxiosError(e)) {
        var data = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data;
        if (data === null || data === void 0 ? void 0 : data.message) {
            if (data.code === "APPLICATION_ASSIGNEE_DENIED" && data.details != null) {
                try {
                    var compact = JSON.stringify(data.details);
                    if (compact.length <= 900) {
                        return "".concat(data.message, "\uFF08").concat(compact, "\uFF09");
                    }
                    return "".concat(data.message, "\uFF08\u8BCA\u65AD\u4FE1\u606F\u8FC7\u957F\uFF0C\u8BF7\u6253\u5F00\u5F00\u53D1\u8005\u5DE5\u5177\u67E5\u770B wecom-login \u54CD\u5E94\u4F53 details\uFF09");
                }
                catch (_c) {
                    return data.message;
                }
            }
            return data.message;
        }
        if (((_b = e.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
            return "服务器拒绝访问（403）。若提示使用人或权限掩码，请在组织管理后台为该应用配置使用人与功能权限。";
        }
    }
    return e instanceof Error ? e.message : "企微登录失败";
}
var wecomOAuthCodeInflight = new Set();
var WecomMsOrgCallbackPageInner = function (_a) {
    var navigate = _a.navigate, searchParams = _a.searchParams, _b = _a.afterLoginNavigateTo, afterLoginNavigateTo = _b === void 0 ? "/" : _b, _c = _a.onErrorNavigateTo, onErrorNavigateTo = _c === void 0 ? "/" : _c, _d = _a.tokenKey, tokenKey = _d === void 0 ? "token" : _d, _e = _a.tokenStorage, tokenStorage = _e === void 0 ? "both" : _e, applicationId = _a.applicationId, msOrgApiBaseUrl = _a.msOrgApiBaseUrl, wecomRedirectUri = _a.wecomRedirectUri, oauthStatePrefix = _a.oauthStatePrefix;
    var clientOpts = React.useMemo(function () { return ({
        applicationId: applicationId,
        msOrgApiBaseUrl: msOrgApiBaseUrl,
        wecomRedirectUri: wecomRedirectUri,
        oauthStatePrefix: oauthStatePrefix,
    }); }, [applicationId, msOrgApiBaseUrl, wecomRedirectUri, oauthStatePrefix]);
    React.useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var code, appId, res, roundtrip;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        code = (searchParams.get("code") || "").trim();
                        if (!code) {
                            toastError("企微回调缺少 code");
                            clearWecomOauthReturnPath();
                            navigate(afterLoginNavigateTo, { replace: true });
                            return [2 /*return*/];
                        }
                        if (wecomOAuthCodeInflight.has(code)) {
                            return [2 /*return*/];
                        }
                        wecomOAuthCodeInflight.add(code);
                        appId = resolveApplicationId(clientOpts);
                        if (!appId) {
                            toastError("未配置 REACT_APP_MSORG_APPLICATION_ID");
                            clearWecomOauthReturnPath();
                            navigate(afterLoginNavigateTo, { replace: true });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, wecomLogin({
                                code: code,
                                applicationId: appId,
                            }, clientOpts)];
                    case 1:
                        res = _a.sent();
                        if (!res.success || !res.token) {
                            throw new Error(res.message || "企微登录失败");
                        }
                        setWecomMsOrgToken(tokenKey, res.token, tokenStorage);
                        roundtrip = getWecomMsOrgToken(tokenKey, tokenStorage);
                        if (roundtrip !== res.token) {
                            setWecomOAuthFail("登录态无法写入浏览器存储（企微 WebView 可能禁用 localStorage/sessionStorage），请尝试升级企微或用系统浏览器打开链接。", "STORAGE_WRITE_FAILED");
                            toastError("登录态无法保存到本机，请重试或换端打开");
                            clearWecomOauthReturnPath();
                            navigate(onErrorNavigateTo, { replace: true });
                            return [2 /*return*/];
                        }
                        clearOauthAttemptFlag();
                        clearWecomOAuthFail();
                        navigate(takeWecomOauthReturnPathOrFallback(afterLoginNavigateTo), { replace: true });
                        return [2 /*return*/];
                }
            });
        }); };
        void run().catch(function (e) {
            var _a;
            var msg = wecomLoginErrorMessage(e);
            var errCode = axios.isAxiosError(e) && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data) && typeof e.response.data === "object"
                ? String(e.response.data.code || "")
                : "";
            setWecomOAuthFail(msg, errCode || undefined);
            toastError(msg);
            clearWecomOauthReturnPath();
            navigate(onErrorNavigateTo, { replace: true });
        });
    }, [
        searchParams,
        navigate,
        afterLoginNavigateTo,
        onErrorNavigateTo,
        tokenKey,
        tokenStorage,
        clientOpts,
    ]);
    return (_jsx("div", __assign({ style: {
            display: "flex",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
        } }, { children: _jsx("span", __assign({ style: { color: "#666", fontSize: 15 } }, { children: "\u4F01\u5FAE\u767B\u5F55\u5904\u7406\u4E2D\u2026" })) })));
};
/** 仅在未注入 navigate 时使用；尽量在宿主页注入以避免双份 router 模块 */
var WecomMsOrgCallbackPageWithRouterHooks = function (props) {
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    return (_jsx(WecomMsOrgCallbackPageInner, __assign({}, props, { navigate: navigate, searchParams: searchParams })));
};
/**
 * 企微 OAuth 回调页：用 code 调 msOrg POST /auth/wecom-login，写入 token 后跳转。
 * CRM 等 Vite+workspace 场景请传入 `navigate` 与 `searchParams`。
 */
export var WecomMsOrgCallbackPage = function (_a) {
    var navigateProp = _a.navigate, searchParamsProp = _a.searchParams, rest = __rest(_a, ["navigate", "searchParams"]);
    if (navigateProp != null && searchParamsProp != null) {
        return (_jsx(WecomMsOrgCallbackPageInner, __assign({}, rest, { navigate: navigateProp, searchParams: searchParamsProp })));
    }
    return _jsx(WecomMsOrgCallbackPageWithRouterHooks, __assign({}, rest));
};
